import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ExposureBySEGs, ExposureByTask, ExposureTaskDistribution, ExposureTaskSample } from 'src/app/models/exposureBySeg.model';

import { SEG } from 'src/app/models/seg.model';
import { Task } from 'src/app/models/task.model';

@Component({
  standalone: false,
  selector: 'app-exposure-by-task',
  templateUrl: './exposure-by-task.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./exposure-by-task.component.scss']
})
export class ExposureByTaskComponent implements OnInit {
  @Input() show: boolean = false;
  @Input() selectedSEG: ExposureBySEGs;
  @Input() selectedTask: ExposureByTask;
  @Input() loadingAllSEGs: boolean = true;
  @Input() loadingExposureTaskSamples: boolean = true;
  @Input() loadingExposureTaskDistribution: boolean = true;
  @Input() exposureTaskSamples: ExposureTaskSample[];
  @Input() exposureTaskDistributions: ExposureTaskDistribution[];
  @Input() exposureAllSEGs: SEG[];
  @Input() showSegReport: boolean = true;
  @Input() selectedTaskGroup: ExposureByTask[];
  @Input() showRep: boolean = false;
  @Input() segTasks: Task[];

  @Output() hideTaskSupervisorEmit = new EventEmitter<any>();
  @Output() redirectToSampleEmit = new EventEmitter<any>();
  @Output() hideSEGDetailEmit = new EventEmitter<any>();
  @Output() showSEGDetailEmit = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    if (this.selectedTask && this.segTasks) {
      this.segTasks = this.segTasks.filter(task => task.taskGroupId === this.selectedTask.taskGroupId);
    }
  }

  hideTaskSupervisorFn(event: Event) {
    this.hideTaskSupervisorEmit.emit(event);
    this.showRep = false;
  }

  hideSEGDetailFn() {
    this.hideSEGDetailEmit.emit(false);
    this.showRep = false;
  }

  showSEGDetailFn() {
    this.showSEGDetailEmit.emit(true);
  }

  hideFormFn(){
    this.hideTaskSupervisorEmit.emit(false);
    this.hideSEGDetailEmit.emit(false);
    this.showRep = false;
  }

  redirectToSample(sensorAssignmentId) {
    this.redirectToSampleEmit.emit(sensorAssignmentId);
  }

  hideForm(){
    this.hideFormFn();
    this.showSEGDetailFn();
  }

  sortExposureTaskSamples(sortData) {
    this.exposureTaskSamples = this.exposureTaskSamples.sort((a, b) => {
      const aValue = (a as any)[sortData.active];
      const bValue = (b as any)[sortData.active];
      return (aValue < bValue ? -1 : 1) * (sortData.direction === 'asc' ? 1 : -1);
    });
  }

}
